import React from 'react';

export const Footer: React.FC = () => {
  return (
    <footer className="footer">
      <div className="footer-content">
        <p>&copy; 2026 REWEAVING Project. All rights reserved.</p>
      </div>
    </footer>
  );
};

